import { CdkStepper } from '@angular/cdk/stepper';
import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NgFor, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss'],
    providers: [{ provide: CdkStepper, useExisting: StepperComponent }],
    standalone: true,
    imports: [NgFor, NgTemplateOutlet]
})
export class StepperComponent extends CdkStepper {

  get isParacelsus(): boolean {
    return environment.style === 'paracelsus';
  }

}
